//3rd Party Components
import React, { Fragment, useEffect } from 'react';
import { useSelector } from "react-redux";

//Components
import '../../styles/mycasa-footer-override.css';

//Actions and Selectors
import { getSystemSelector } from '../../PortalStore/Selectors/EnvDataSelectors';

const CasaFooter = () => {
    let environment = useSelector(state => getSystemSelector(state, "Portal - Portal Environment"));

    function getCdnUrl(environment) {

        if (environment === 'SDT-DEV1') {
            return 'https://cdnsdtdev.casa.gov.au/';
        }
        else if (environment === 'SDT-DEV2') {
            return 'https://cdnsdtd2.casa.gov.au/';
        }
        else if (environment === 'SDT-TEST' || environment === 'SDT-Test') {
            return 'https://cdnsdttst.casa.gov.au/';
        }
        else if (environment === 'SDT-UAT') {
            return 'https://cdnsdtuat.casa.gov.au/';
        }
        else if (environment === 'PREPROD') {
            return 'https://cdnpreprd.casa.gov.au/';
        }
        else if (environment === 'Production') {
            return 'https://cdn.casa.gov.au/';
        }
    }
    var cdnUrl = getCdnUrl(environment);

    useEffect(() => {
        const script = document.createElement('script');

        if (cdnUrl != undefined) {
            script.src = cdnUrl + "Common/components/footer.js";
            document.body.appendChild(script);
            var head = document.getElementsByTagName('head')[0];
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.href = cdnUrl + 'Common/styles/mycasa-footer.css';
            link.media = 'all';
            head.appendChild(link);

            return () => {
                document.body.removeChild(script);
            }
        }
    }, []);
    return (
        <div className='paddingTop'>
            <footer-component src={cdnUrl}></footer-component>
        </div>
    )

}

export default CasaFooter;


